type VehicleDataItemProps = {
    title: string;
    value: string | number;
};

const VehicleDataItem = ({ title, value }: VehicleDataItemProps) => {
    return (
        <div className="flex items-start justify-between gap-4">
            <span className="text-color-dark text-size-14">{title}</span>

            <span className="text-color-darker text-size-16 text-right">
                {value || '-'}
            </span>
        </div>
    );
};

const VehicleData = () => {
    const vehicleData = [
        {
            title: 'Proprietário do Veículo',
            value: '-',
        },
        {
            title: 'Modelo',
            value: '-',
        },
        {
            title: 'Chassi',
            value: '-',
        },
        {
            title: 'Placa',
            value: '-',
        },
        {
            title: 'Descrição Cor',
            value: '-',
        },
        {
            title: 'Tipo Implemento',
            value: '-',
        },
        {
            title: 'Data Produção',
            value: '-',
        },
        {
            title: 'Data Faturamento',
            value: '-',
        },
        {
            title: 'Data entrega TS',
            value: '-',
        },
        {
            title: 'Dealer Responsável',
            value: '-',
        },
        {
            title: 'Fim garantia 0',
            value: '-',
        },
        {
            title: 'Fim garantia adicional (B)',
            value: '-',
        },
        {
            title: 'Numero contrato manutenção 1',
            value: '-',
        },
        {
            title: 'Modalidade contrato manutenção 1',
            value: '-',
        },
        {
            title: 'Status veículo contrato 1',
            value: '-',
        },
        {
            title: 'Início Contrato Manutenção 1',
            value: '-',
        },
        {
            title: 'Fim Contrato Manutenção 1',
            value: '-',
        },
        {
            title: 'Limite Km Contrato Manutenção 1',
            value: '-',
        },
        {
            title: 'Inicio Garantia Especial (A)',
            value: '-',
        },
        {
            title: 'Fim Garantia Especial (A)',
            value: '-',
        },
        {
            title: 'Adesão 1 Garantia Especial (A)',
            value: '-',
        },
        {
            title: 'Tipo cobertura adesão 1 Garantia adicional (B)',
            value: '-',
        },
        {
            title: 'Adesão 2 garantia especial (A)',
            value: '-',
        },
        {
            title: 'Tipo Cobertura Adesão 2 Garantia Especial (A)',
            value: '-',
        },
        {
            title: 'Campanhas Pendentes',
            value: '-',
        },
        {
            title: 'Última atualização',
            value: '-',
        },
        {
            title: 'Consultar jurídico',
            value: '-',
        },
        {
            title: 'Veículo impedido',
            value: '-',
        },
        {
            title: 'Garantia',
            value: '-',
        },
        {
            title: 'Possui garantia VolksConfia',
            value: '-',
        },
        {
            title: 'Inicio garantia VolksConfia',
            value: '-',
        },
        {
            title: 'Fim garantia VolksConfia',
            value: '-',
        },
    ];

    return (
        <div className="border rounded width-100pct height-100pct padding-15">
            <div className="margin-bottom-15">
                <span className="text-size-16 text-medium ">
                    Dados do veículo
                </span>
            </div>

            <div className="display-flex flex-column">
                {vehicleData.map(item => (
                    <VehicleDataItem
                        key={item.title}
                        title={item.title}
                        value={item.value}
                    />
                ))}
            </div>
        </div>
    );
};

export default VehicleData;